import React, { ReactNode, HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import BuyNowTextBoxWithAdornments from "components/textBoxes/buyNow/BuyNowTextBoxWithAdornments";
import Scribble from "components/scribble/Scribble";
import clsx from "clsx";
import { ScribbleVariant } from "components/scribble/ScribbleImage";

type EditionPlacement = "left" | "right";

const useStyles = (placement: EditionPlacement) =>
    makeStyles((theme: Theme) => {
        const placementMarginAmount = theme.spacing(2);

        return createStyles({
            root: {},
            keyArt: {
                "& img": {
                    width: "100%",
                },
                marginRight: placement === "left" ? placementMarginAmount : 0,
                marginLeft: placement === "right" ? placementMarginAmount : 0,
            },
            title: {},
            textBox: {
                marginTop: "-14%",
                [theme.breakpoints.down("xs")]: {
                    marginTop: "-13%",
                },
                marginLeft: placement === "left" ? placementMarginAmount : 0,
                marginRight: placement === "right" ? placementMarginAmount : 0,
            },
            scribbleContainer: {
                width: "75%",
                height: "auto",
            },
            scribbleContainerLeft: {
                top: "-1%",
                left: "-12%",
            },
            scribbleContainerRight: {
                right: "-35px",
                bottom: "-50px",
            },
            childContainer: {},
        });
    });

interface IProps extends HTMLAttributes<HTMLDivElement> {
    keyArt: ReactNode;
    editionTitle: ReactNode;
    placement: EditionPlacement;
}

export default function Edition(props: IProps) {
    const { keyArt, editionTitle, placement, children, ...rest } = props;

    const classes = useStyles(placement)();

    const scribbleVariant: ScribbleVariant = placement === "left" ? "v1" : "v2";

    return (
        <div {...rest}>
            <div className={classes.keyArt}>{keyArt}</div>
            <Scribble
                variant={scribbleVariant}
                classes={{
                    root: classes.textBox,
                    scribbleContainer: clsx(
                        classes.scribbleContainer,
                        placement === "left"
                            ? classes.scribbleContainerLeft
                            : classes.scribbleContainerRight
                    ),
                    childContainer: classes.childContainer,
                }}
            >
                <BuyNowTextBoxWithAdornments
                    titlePrefixComponent={<div className={classes.title}>{editionTitle}</div>}
                >
                    {children}
                </BuyNowTextBoxWithAdornments>
            </Scribble>
        </div>
    );
}
